"use client";
import React from "react";

import IconLocation from "@/icons/location.svg";
import { SearchService } from "@/services/search.service";
import { cn } from "@/utils/cn";
import { getLocaleLocation } from "@/utils/getLocaleLocation";
import { useQuery } from "@tanstack/react-query";
import { useLocale, useTranslations } from "next-intl";
import { useLocationData } from "../../AddObject/Steps/Preview/hooks/useLocationData";

interface Props {
  country?: string;
  region?: string;
  city?: string;
  district?: string;
  microdistrict?: string;
  street?: string;
  number?: string;
  className?: string;
}

const LocationTitle: React.FC<Props> = React.memo((props) => {
  const {
    country,
    region,
    city,
    district,
    microdistrict,
    street,
    number,
    className,
  } = props;

  const { getLocalizedLocationName } = useLocationData();
  const location = [country, region, city].filter(Boolean);
  const address = [
    getLocalizedLocationName(district, "district"),
    getLocalizedLocationName(microdistrict, "microdistricts"),
    getLocalizedLocationName(street, "street"),
    number,
  ].filter(Boolean);
  const locale = useLocale();
  const t = useTranslations("countries");

  const { data: regionsListData } = useQuery({
    queryKey: ["getRegions"],
    queryFn: () => SearchService.getRegions(),
  });

  return (
    <div
      className={cn(
        "grid grid-cols-[min-content,1fr] gap-x-4 items-center",
        className,
      )}
    >
      <IconLocation
        stroke={1}
        className={cn("icon  text-[#444444]", {
          "row-span-2 self-baseline mt-1": address.length && address.length,
        })}
      />
      {regionsListData && location.length ? (
        <p className={"pt-[0.4rem] text-[1.6rem] font-medium text-[#323232]"}>
          {getLocaleLocation(regionsListData, locale, {
            city,
            country: country ? t(country) : "",
            region,
          }).join(", ")}
        </p>
      ) : null}
      {address.length ? (
        <p className="text-[1.5rem] text-[#444444]">{address.join(", ")}</p>
      ) : null}
    </div>
  );
});

LocationTitle.displayName = "LocationTitle";

export default LocationTitle;
